import React from 'react';
import {
  Stack, Text, UnorderedList, withTranslation, Link, Trans,
} from '@piwikpro/ui-components';
import { TFunction } from 'react-i18next';

interface ConfirmationModalBodyProps {
  showSamlMessage: boolean
  t: TFunction
}

const ConfirmationModalBody: React.FunctionComponent<ConfirmationModalBodyProps> = (
  { t, showSamlMessage },
) => {
  let body;
  if (showSamlMessage) {
    body = (
      <>
        <Stack.Item>
          <Text as="p">
            {t('platform.domains.removeDomain.modal.saml-message1')}
          </Text>
        </Stack.Item>
        <Stack.Item previousSpacing="none">
          <UnorderedList>
            <UnorderedList.Item>
              <Trans
                t={t}
                parent="span"
                i18nKey="platform.domains.removeDomain.modal.saml-bullet-point1"
                components={[
                  <Link href="https://help.piwik.pro/support/account/saml-single-sign-on/">Read more</Link>,
                ]}
              />
            </UnorderedList.Item>
            <UnorderedList.Item>
              <Text as="p">{t('platform.domains.removeDomain.modal.saml-bullet-point2')}</Text>
            </UnorderedList.Item>
          </UnorderedList>
        </Stack.Item>
      </>
    );
  } else {
    body = (
      <Stack.Item>
        <Text as="p">
          {t('platform.domains.removeDomain.modal.message1')}
        </Text>
      </Stack.Item>
    );
  }

  return (
    <Stack vertical spacing="narrow">
      {body}
      <Stack.Item>
        <Text as="p">
          {t('platform.domains.removeDomain.modal.message2')}
        </Text>
      </Stack.Item>
    </Stack>
  );
};

export default withTranslation(['administration'])(ConfirmationModalBody);
